export default "__VITE_ASSET__lfuV$aB0__"